import React, { createContext, useContext } from 'react';
import { ModalPortal } from '../../../components';
import css from './StrategiesListModal.css';
import {
    AvatarRiderS,
    IconCameraL,
    // IconLogoInstagramL,
    IconSocialFacebookL,
    IconUploadL,
} from '../../../icons';
import { useUploadImageWizardContext } from '../UploadImageWizard';
import {
    STEP_UPLOAD_PIC_LIST,
    UPLOAD_TYPE_CAMERA_PHOTO,
    UPLOAD_TYPE_DEFAULT_PIC,
    UPLOAD_TYPE_FB_PIC,
    // UPLOAD_TYPE_INSTA_PIC,
} from '../helpers';

const StrategiesListContext = createContext(undefined);

const useStrategiesListContext = () => {
    const context = useContext(StrategiesListContext);

    if (!context) {
        throw new Error('useStrategiesListContext must be used within StrategiesListContext.');
    }

    return context;
};

export const StrategiesListModal = ({ children, uploadInProgress, uploadDisabled }) => {
    const { uploadState, setUploadState } = useUploadImageWizardContext();
    const isListState = uploadState === STEP_UPLOAD_PIC_LIST;

    if (!isListState) return null;

    const onClose = () => setUploadState(null);

    return (
        <StrategiesListContext.Provider value={{ uploadInProgress, uploadDisabled }}>
            <ModalPortal
                id="StrategiesListModal"
                isOpen
                onClose={onClose}
                containerClassName={css.modalContainer}
                contentClassName={css.modalContent}
                containerClassNameJoined
            >
                {children}
            </ModalPortal>
        </StrategiesListContext.Provider>
    );
};

const Heading = ({ children }) =>
    children || (
        <>
            <h3>Profilbild hochladen</h3>
            <p>Wähle ein Profilbild aus, das zeigt, wie Du bist.</p>
        </>
    );

const Container = ({ children }) => <div className={css.container}>{children}</div>;

const PcImage = ({
    children,
    onPcFileUpload,
    fieldName = 'profileImage',
    icon,
    label,
    labelRef = null,
    isMultiple,
    accept = 'image/video/*',
    inputProps = {},
}) => {
    const { uploadDisabled, uploadInProgress } = useStrategiesListContext();
    const { setStrategy, setUploadState, setSrc } = useUploadImageWizardContext();

    const disabled = uploadInProgress || uploadDisabled;

    return (
        <label className={css.strategyHolder} htmlFor={fieldName} ref={labelRef}>
            {icon || <IconUploadL />}
            <p>{label || 'Foto hochladen'}</p>
            {children || (
                <input
                    type="file"
                    accept={accept}
                    name={fieldName}
                    id={fieldName}
                    className={css.uploadAvatarInput}
                    disabled={disabled}
                    multiple={isMultiple}
                    onChange={e => {
                        e.preventDefault();

                        let files;

                        if (e.dataTransfer) {
                            files = e.dataTransfer.files;
                        } else if (e.target) {
                            files = e.target.files;
                        }
                        onPcFileUpload(files, { setStrategy, setUploadState, setSrc });
                    }}
                    {...inputProps}
                />
            )}
        </label>
    );
};

const Pic = ({ label, isNew, icon, clickHandler, strategyId }) => {
    const { setStrategy } = useUploadImageWizardContext();
    const defaultHandler = () => setStrategy(strategyId);

    const onClick = typeof clickHandler === 'function' ? clickHandler : defaultHandler;

    return (
        <div className={css.strategyHolder} onClick={onClick}>
            {icon}
            <p>{label}</p>
            {isNew && <span className={css.newItemBadge}>Neu</span>}
        </div>
    );
};

const CamerPhoto = props => (
    <Pic
        icon={<IconCameraL />}
        label="Foto machen"
        strategyId={UPLOAD_TYPE_CAMERA_PHOTO}
        {...props}
    />
);

const FacebookPic = props => (
    <Pic
        icon={<IconSocialFacebookL />}
        label="Aus Facebook"
        strategyId={UPLOAD_TYPE_FB_PIC}
        isNew
        {...props}
    />
);

// const InstagramPic = props => (
//     <Pic
//         icon={<IconLogoInstagramL />}
//         label="Aus Instagram"
//         strategyId={UPLOAD_TYPE_INSTA_PIC}
//         isNew
//         {...props}
//     />
// );

const Default = props => (
    <Pic
        icon={<AvatarRiderS />}
        label="Avatar auswählen"
        strategyId={UPLOAD_TYPE_DEFAULT_PIC}
        isNew
        {...props}
    />
);

StrategiesListModal.Heading = Heading;
StrategiesListModal.Container = Container;
StrategiesListModal.PcImage = PcImage;
StrategiesListModal.Pic = Pic;
StrategiesListModal.CamerPhoto = CamerPhoto;
StrategiesListModal.FacebookPic = FacebookPic;
// StrategiesListModal.InstagramPic = InstagramPic;
StrategiesListModal.Default = Default;
